var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtCalculate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M79.355 79.66v120.99H55.77v-96.256l-22.426.497v-17.01zm167.28 0-.008 120.99h-23.59v-96.256l-22.414.497v-17.01zm-86.965 20.83v32.89h25.413v21.095H159.67v34.054h-22.344v-34.054H111.83V133.38h25.496V100.49z"
})));
export default SvgQtCalculate;